import {Param, Types} from "@proleis/proleis-rest-client";


export class ProjectStatusModel {
  PROJECT_INFO_ID: number;
  TIMELABEL: string;
  TEXT_COMMENT: string;
  DATE_LAST_ETA: string;
  DATE_MAT_RECEIPT: string;
  DATE_MAF_DATA: string;
  DATE_CAD_FINISHED: string;
  DATE_CAST_LAST_OP: string;
  DATE_DIE_MIILING_FIRST_OP: string;
  DATE_DIE_MIILING_LAST_OP: string;
  DATE_DIE_ASSEMBLY_FIRST_OP: string;
  DATE_PRESS_PART_FIRST: string;
  DATE_LASER_PART: string;
  DATE_MEASURE_PROTOCOL: string;
  DATE_LAST_CHANGE: string;
  DATE_DELIVERY: string;
  LINK_PSE_WERKZEUGART_ID: number;
  LINK_PSE_KONSTRUKTION_STATUS_ID: number;
  NUM_MAT_THICKNESS: string;
  NUM_COMPLEXITY: number;
  DATE_QS_LOOP: Date;
  PREV_DATE_QS_LOOP: Date;
  PRODUCTION_PROGRESS: number;

  [key: string]: any;

  public static toParameters(status: ProjectStatusModel): Param[] {
    const params: Param[] = [];
    for (const [key, value] of Object.entries(status)) {
      if (!key.includes('PROJECT_INFO') && key !== 'PRIMARYNAME' && key !== 'METANAME' && key !== 'TEIL_QA_DATE') {
        if ((typeof value === 'string' || typeof value === 'object') && key.includes('DATE')) {
          params.push({
            name: key,
            value: new Date(value).toISOString(),
            type: Types.DATE
          });
        } else if (typeof value === 'string' && !key.includes('DATE')) {
          params.push({
            name: key,
            value,
            type: Types.TEXT
          });
        } else if (typeof value === 'number') {
          params.push({
            name: key,
            value,
            type: Types.DOUBLE
          });
        } else if (typeof value === 'boolean') {
          params.push({
            name: key,
            value,
            type: Types.BOOL
          });
        } else {
          params.push({
            name: key,
            value,
            type: Types.TEXT
          });
        }
      }
    }
    return params;
  }
}
